import Utility from './UtilityFunctions';

$(document).on('click', '.accordion-title', function (e) {
    // skip if triggered by Accordion Vue component
    if ($(this).hasClass('accordion-component-item')) {
        return;
    }

    Utility.slideToggleAndScroll(e);
});
